/**
 * Designer Appliances - Mobile Drawer Navigation Controller
 */
document.addEventListener('DOMContentLoaded', () => {
  const drawerContainer = document.querySelector('header-drawer details.da-mob-details');
  if (!drawerContainer) return;

  const mobileAccountButton = document.querySelector('.da-mob-action-btn');
  const accountDrawer = document.querySelector('.account-drawer');
  const openDialogFromMobile = (button, dialog) => {
    if (!button || !dialog) return;
    button.addEventListener('click', () => {
      drawerContainer.removeAttribute('open');
      dialog.showDialog(button);
    });
  };

  openDialogFromMobile(mobileAccountButton, accountDrawer);

  const mobileCartButton = document.querySelector('.da-mob-cart-btn');
  const cartDrawer = document.querySelector('cart-drawer-component');
  openDialogFromMobile(mobileCartButton, cartDrawer);

  // 1. Close Button Handler
  const closeBtn = document.getElementById('da-mob-close-btn');
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      drawerContainer.removeAttribute('open');
      document.body.style.overflow = '';
      resetToMainMenu();
    });
  }

  // Handle open state body scroll lock
  drawerContainer.addEventListener('toggle', () => {
    if (drawerContainer.hasAttribute('open')) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
      resetToMainMenu();
    }
  });

  // 2. Navigation Drill-Down
  const panels = document.querySelectorAll('.da-mob-panel');

  function showPanel(panelId) {
    panels.forEach((p) => p.classList.remove('active'));
    const target = document.getElementById(panelId);
    if (target) {
      target.classList.add('active');
      const panelsScrollContainer = document.querySelector('.da-mob-panels-container');
      if (panelsScrollContainer) panelsScrollContainer.scrollTop = 0;
    }
  }

  function resetToMainMenu() {
    showPanel('da-mob-panel-main');
  }

  // Drill down buttons (forward)
  document.querySelectorAll('.da-mob-nav-btn, .da-mob-subnav-btn').forEach((btn) => {
    btn.addEventListener('click', function () {
      const targetId = this.getAttribute('data-target');
      const returnTo = this.getAttribute('data-return-to');

      if (targetId) {
        if (returnTo) {
          const targetPanel = document.getElementById(targetId);
          if (targetPanel) {
            const backBtn = targetPanel.querySelector('.da-mob-back-btn');
            if (backBtn) backBtn.setAttribute('data-back', returnTo);
          }
        }
        showPanel(targetId);
      }
    });
  });

  // Back buttons (reverse)
  document.querySelectorAll('.da-mob-back-btn').forEach((btn) => {
    btn.addEventListener('click', function () {
      const backId = this.getAttribute('data-back');
      if (backId) {
        showPanel(backId);
      } else {
        resetToMainMenu();
      }
    });
  });

  // 3. Alphabet Filter Tabs inside Mobile All Brands
  document.querySelectorAll('.da-mob-alpha-btn').forEach((btn) => {
    btn.addEventListener('click', function () {
      const alphaKey = this.getAttribute('data-mob-alpha');
      const container = this.closest('.da-mob-panel-content');
      if (!container || !alphaKey) return;

      container.querySelectorAll('.da-mob-alpha-btn').forEach((b) => b.classList.remove('active'));
      this.classList.add('active');

      container.querySelectorAll('.da-mob-alpha-panel').forEach((p) => p.classList.remove('active'));
      const target = container.querySelector(`#da-mob-alpha-${alphaKey}`);
      if (target) target.classList.add('active');
    });
  });
});
